var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6673 5.83337H6.66732C6.3137 5.83337 5.97456 5.97385 5.72451 6.2239C5.47446 6.47395 5.33398 6.81309 5.33398 7.16671C5.33398 7.52033 5.47446 7.85947 5.72451 8.10952C5.97456 8.35956 6.3137 8.50004 6.66732 8.50004H9.33398C9.68761 8.50004 10.0267 8.64052 10.2768 8.89057C10.5268 9.14061 10.6673 9.47975 10.6673 9.83337C10.6673 10.187 10.5268 10.5261 10.2768 10.7762C10.0267 11.0262 9.68761 11.1667 9.33398 11.1667H5.33398M8.00065 12.5V4.50004M14.6673 8.50004C14.6673 12.1819 11.6825 15.1667 8.00065 15.1667C4.31875 15.1667 1.33398 12.1819 1.33398 8.50004C1.33398 4.81814 4.31875 1.83337 8.00065 1.83337C11.6825 1.83337 14.6673 4.81814 14.6673 8.50004Z",
    stroke: "#828FAB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.c7ad7776b479596b5404fb8f853a8006.svg";
export { ForwardRef as ReactComponent };